// extracted by mini-css-extract-plugin
module.exports = {"word":"e553085a3e8b78afe876a8981ee421e3"};